import React, { useState } from "react";

const DocumentDetailsModal = ({ showModal, setShowModal, handleAddDocument }) => {
    const [documentDetails, setDocumentDetails] = useState({
        itemName: "",
        documentType: "",
        documentDetails: "",
        file: null,
    });

    const itemNames = ["Item 1", "Item 2", "Item 3", "Item 4"]; // Replace with dynamic data if necessary
    const documentTypes = ["Invoice", "Warranty", "Receipt", "Others"]; // Replace with dynamic data if necessary

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDocumentDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setDocumentDetails((prev) => ({ ...prev, file }));
    };

    const handleSubmit = () => {
        handleAddDocument(documentDetails);
        setShowModal(false);
    };

    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content shadow-lg rounded">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">Upload Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    {/* Item Name */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Item Name</label>
                                        <select
                                            name="itemName"
                                            className="form-select"
                                            value={documentDetails.itemName}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Item Name</option>
                                            {itemNames.map((name, index) => (
                                                <option key={index} value={name}>
                                                    {name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Document Type */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Document Type</label>
                                        <select
                                            name="documentType"
                                            className="form-select"
                                            value={documentDetails.documentType}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Document Type</option>
                                            {documentTypes.map((type, index) => (
                                                <option key={index} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Document Details */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Document Details</label>
                                        <textarea
                                            name="documentDetails"
                                            className="form-control"
                                            value={documentDetails.documentDetails}
                                            onChange={handleChange}
                                            placeholder="Provide details about the document"
                                        />
                                    </div>

                                    {/* Upload File */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Upload File</label>
                                        <input
                                            type="file"
                                            name="file"
                                            className="form-control"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    Save 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DocumentDetailsModal;
